
import React, { useState } from 'react';

import { IoMdPeople } from "react-icons/io";
import { MdAccountTree, MdPeopleAlt, MdCategory, MdAccountBalance } from "react-icons/md";
import { FaFileContract } from "react-icons/fa";

import {  columnsDataContracts } from "./variables/columnsData";
import OrgansTable from "./components/OrgansTable";
import EmployeesTable from "./components/EmployeesTable";
import BeneficiaryTable from "./components/BeneficiaryTable";
import AccountTable from "./components/AccountTable";
import NatureTable from "./components/NatureTable";
import ContractsTable from "./components/ContractsTable";

import tableDataComplex from "./variables/tableDataComplex.json";

const Dashboard = () => {

  // State to track selected widget
  const [selectedWidget, setSelectedWidget] = useState(null);

  // Widget data to map over
  const widgets = [
    { icon: <MdAccountTree className="h-7 w-7" />, title: "Orgãos" },
    { icon: <IoMdPeople className="h-6 w-6" />, title: "Funcionários" },
    { icon: <MdPeopleAlt className="h-7 w-7" />, title: "Beneficiários" },
    // { icon: <FaFileContract className="h-6 w-6" />, title: "Contratos" },
    { icon: <MdCategory className="h-6 w-6" />, title: "Naturezas" },
    { icon: <MdAccountBalance className="h-7 w-7" />, title: "Contas" },
  ];

   // Table data components to match each widget
   const tables = [
    <OrgansTable />,
    <EmployeesTable />,
    <BeneficiaryTable />,
    // <ContractsTable columnsData={columnsDataContracts} tableData={tableDataComplex} />,
    <NatureTable />,
    <AccountTable />,
  ];

  return (
    <div>
      {/* Widget Options */}
      <div className="mt-3 grid grid-cols-1 gap-5 md:grid-cols-5 lg:grid-cols-5 2xl:grid-cols-5 3xl:grid-cols-5">
  {widgets.map((widget, index) => (
    <div
      key={index}
      onClick={() => setSelectedWidget(index)}
      className={`p-4 rounded-lg cursor-pointer flex items-center ${
        selectedWidget === index ? 'bg-brand-500 text-white' : 'bg-gray-100 text-gray-700'
      } hover:bg-brand-500`}
    >
      <div className="mr-2">{widget.icon}</div> {/* Add some margin to space out the icon and text */}
      <p>{widget.title}</p>
    </div>
  ))}
</div>


      {/* Table Display */}
      <div className="mt-5">
        {tables[selectedWidget]}
      </div>
    </div>
  );
};

export default Dashboard;
